import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Product } from '../types';

interface ProductStore {
  products: Product[];
  addProduct: (product: Omit<Product, 'id'>) => void;
  updateProduct: (id: string, updates: Partial<Product>) => void;
  deleteProduct: (id: string) => void;
  getProduct: (id: string) => Product | undefined;
}

const initialState = {
  products: [{
    id: 'test-product-1',
    name: 'Premium Course',
    description: 'Complete course with all materials and lifetime access',
    price: 2999,
    active: true,
    type: 'main',
  }],
};

export const useProductStore = create<ProductStore>()(
  persist(
    (set, get) => ({
      ...initialState,
      addProduct: (product) => set((state) => ({
        products: [...state.products, { ...product, id: crypto.randomUUID() }]
      })),
      updateProduct: (id, updates) => set((state) => ({
        products: state.products.map((p) => 
          p.id === id ? { ...p, ...updates } : p
        )
      })),
      deleteProduct: (id) => set((state) => ({
        products: state.products.filter((p) => p.id !== id)
      })),
      getProduct: (id) => get().products.find((p) => p.id === id),
    }),
    {
      name: 'product-store',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      migrate: (persistedState: any, version: number) => {
        if (version === 0) {
          // Migration from version 0 to 1
          return {
            ...initialState,
            ...persistedState,
            products: persistedState.products || initialState.products,
          };
        }
        return persistedState;
      },
    }
  )
);